
import { Row, Container } from 'react-bootstrap';
import { Component } from 'react';

class Separator extends Component{

    render(){
        return(
            <Container className="separator-container" />
        )
    }
}

export default (Separator);